import publicPathPrefix from '@lib/utils/publicPathPrefix'
__webpack_public_path__ = publicPathPrefix + '/'
